import type { GridConfig } from '@coursera-web/cds-labs';

export const COACH_SIDE_COLUMN_GRID_CONFIG: GridConfig = { xs: 12, sm: 6, md: 5, lg: 3 };
